import React from 'react';

import CardDialog from '~/components/CardDialog';
import InnerTabs from '~/components/core/Layout/InnerTabs/InnerTabs';
import OperationsBreadcrumbs from '~/components/SystemConfiguration/OperationsBreadcrumbs';

import CliveFeatureFlags from './CliveFeatureFlags';
import CliveRelatedCmsFeatureFlagsTable from './CliveRelatedCmsFeatureFlagsTable';

const CliveFeatureFlagsTab: React.FC = () => {
  const tabs = [
    {
      label: 'Clive Feature Flags',
      url: 'clive',
      component: CliveFeatureFlags,
    },
    {
      label: 'CMS Feature Flags',
      url: 'cms',
      component: CliveRelatedCmsFeatureFlagsTable,
    },
  ];

  return (
    <CardDialog noCardTitle>
      <OperationsBreadcrumbs currentTab="Feature Flags" />
      <InnerTabs tabs={tabs} />
    </CardDialog>
  );
};

export default CliveFeatureFlagsTab;
